// extracted by mini-css-extract-plugin
module.exports = {"area":"bhk69","cardArea":"_9DdwB","card":"_24xLl _2s-6N","cardHeader":"_2x3CS","cardTitle":"_14K4Q"};